// import React, { useState, useEffect } from 'react';
// import { db, ref } from '../firebase';
// import { onValue } from 'firebase/database';
// import Footer from './Footer';
// import { useNavigate } from 'react-router-dom';
// import { 
//   FaStar, 
//   FaRegStar, 
//   FaSearch, 
//   FaFilter, 
//   FaTimes, 
//   FaShoppingCart,
//   FaHeart,
//   FaRegHeart,
//   FaEye,
//   FaTag,
//   FaGift,
//   FaShieldAlt,
//   FaTruck
// } from 'react-icons/fa';
// import { BsGridFill, BsList, BsChevronDown, BsStarFill } from 'react-icons/bs';
// import { HiOutlineSparkles, HiOutlineFire } from 'react-icons/hi';
// import styled, { keyframes } from 'styled-components';
// import Navbar from './Navbar';

// // Enhanced Keyframe Animations
// const slideInFromLeft = keyframes`
//   from {
//     transform: translateX(-50px);
//     opacity: 0;
//   }
//   to {
//     transform: translateX(0);
//     opacity: 1;
//   }
// `;

// const slideInFromRight = keyframes`
//   from {
//     transform: translateX(50px);
//     opacity: 0;
//   }
//   to {
//     transform: translateX(0);
//     opacity: 1;
//   }
// `;

// const fadeInUp = keyframes`
//   from {
//     transform: translateY(30px);
//     opacity: 0;
//   }
//   to {
//     transform: translateY(0);
//     opacity: 1;
//   }
// `;

// const fadeInDown = keyframes`
//   from {
//     transform: translateY(-20px);
//     opacity: 0;
//   }
//   to {
//     transform: translateY(0);
//     opacity: 1;
//   }
// `;

// const scaleIn = keyframes`
//   from {
//     transform: scale(0.9);
//     opacity: 0;
//   }
//   to {
//     transform: scale(1);
//     opacity: 1;
//   }
// `;

// const pulse = keyframes`
//   0%, 100% { transform: scale(1); }
//   50% { transform: scale(1.05); }
// `;

// const shimmer = keyframes`
//   0% { background-position: -200% 0; }
//   100% { background-position: 200% 0; }
// `;

// const floatAnimation = keyframes`
//   0%, 100% { transform: translateY(0px); }
//   50% { transform: translateY(-8px); }
// `;

// const spin = keyframes`
//   0% { transform: rotate(0deg); }
//   100% { transform: rotate(360deg); }
// `;

// const sparkle = keyframes`
//   0%, 100% { opacity: 0; transform: scale(0.8) rotate(0deg); }
//   50% { opacity: 1; transform: scale(1) rotate(180deg); }
// `;

// // Enhanced Styled Components
// const PageContainer = styled.div`
//   min-height: 100vh;
//   background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
//   position: relative;
//   overflow: hidden;
  
//   &:before {
//     content: '';
//     position: absolute;
//     top: 0;
//     left: 0;
//     right: 0;
//     bottom: 0;
//     background: 
//       radial-gradient(circle at 20% 50%, rgba(99, 102, 241, 0.03) 0%, transparent 50%),
//       radial-gradient(circle at 80% 20%, rgba(236, 72, 153, 0.03) 0%, transparent 50%),
//       radial-gradient(circle at 40% 80%, rgba(14, 165, 233, 0.03) 0%, transparent 50%);
//     animation: ${floatAnimation} 20s ease-in-out infinite;
//   }
// `;

// const MainContent = styled.div`
//   position: relative;
//   z-index: 1;
//   padding: 2rem;
//   max-width: 1600px;
//   margin: 0 auto;
  
//   @media (max-width: 768px) {
//     padding: 1rem;
//   }
// `;

// const PageHeader = styled.div`
//   margin-bottom: 3rem;
//   animation: ${fadeInDown} 0.8s ease-out;
// `;

// const PageTitle = styled.h1`
//   font-size: 3rem;
//   font-weight: 800;
//   background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//   -webkit-background-clip: text;
//   -webkit-text-fill-color: transparent;
//   margin: 0 0 1rem 0;
//   line-height: 1.2;
//   position: relative;
  
//   &:after {
//     content: '✨';
//     position: absolute;
//     top: -10px;
//     right: -40px;
//     font-size: 2rem;
//     animation: ${sparkle} 2s ease-in-out infinite;
//   }
  
//   @media (max-width: 768px) {
//     font-size: 2.2rem;
    
//     &:after {
//       right: -30px;
//       font-size: 1.5rem;
//     }
//   }
// `;

// const ControlsContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 1.5rem;
//   animation: ${fadeInUp} 0.8s ease-out 0.2s both;
// `;

// const SearchContainer = styled.div`
//   position: relative;
//   max-width: 600px;
  
//   .search-icon {
//     position: absolute;
//     top: 50%;
//     left: 1.25rem;
//     transform: translateY(-50%);
//     color: #667eea;
//     font-size: 1.1rem;
//   }
// `;

// const SearchInput = styled.input`
//   width: 100%;
//   padding: 1rem 1.25rem 1rem 3rem;
//   border: 2px solid rgba(99, 102, 241, 0.2);
//   border-radius: 50px;
//   background: rgba(255, 255, 255, 0.9);
//   font-size: 1rem;
//   outline: none;
//   transition: all 0.3s ease;
//   backdrop-filter: blur(10px);
//   box-shadow: 0 4px 15px rgba(99, 102, 241, 0.1);
  
//   &:focus {
//     border-color: #667eea;
//     box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.1);
//     background: white;
//   }
  
//   &::placeholder {
//     color: #9ca3af;
//   }
// `;

// const SecondaryControls = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 1rem;
//   flex-wrap: wrap;
  
//   @media (max-width: 768px) {
//     justify-content: space-between;
//   }
// `;

// const ViewToggle = styled.div`
//   display: flex;
//   align-items: center;
//   background: rgba(255, 255, 255, 0.9);
//   border-radius: 50px;
//   padding: 0.5rem;
//   box-shadow: 0 4px 15px rgba(99, 102, 241, 0.1);
//   backdrop-filter: blur(10px);
//   border: 2px solid rgba(99, 102, 241, 0.1);
// `;

// const ViewButton = styled.button`
//   padding: 0.75rem;
//   border-radius: 50px;
//   background: ${props => props.active ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'transparent'};
//   color: ${props => props.active ? 'white' : '#64748b'};
//   border: none;
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   transition: all 0.3s ease;
  
//   &:hover {
//     background: ${props => props.active ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'rgba(99, 102, 241, 0.1)'};
//     color: ${props => props.active ? 'white' : '#667eea'};
//   }
// `;

// const SortSelect = styled.div`
//   position: relative;
  
//   select {
//     padding: 0.875rem 2.5rem 0.875rem 1.25rem;
//     border: 2px solid rgba(99, 102, 241, 0.2);
//     border-radius: 50px;
//     background: rgba(255, 255, 255, 0.9);
//     font-size: 1rem;
//     appearance: none;
//     outline: none;
//     cursor: pointer;
//     transition: all 0.3s ease;
//     backdrop-filter: blur(10px);
//     box-shadow: 0 4px 15px rgba(99, 102, 241, 0.1);
//     min-width: 200px;
    
//     &:focus {
//       border-color: #667eea;
//       box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.1);
//     }
//   }
  
//   .dropdown-icon {
//     position: absolute;
//     right: 1rem;
//     top: 50%;
//     transform: translateY(-50%);
//     pointer-events: none;
//     color: #667eea;
//   }
// `;

// const FilterButton = styled.button`
//   display: flex;
//   align-items: center;
//   gap: 0.75rem;
//   padding: 0.875rem 1.5rem;
//   background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//   border: none;
//   border-radius: 50px;
//   color: white;
//   cursor: pointer;
//   font-size: 1rem;
//   font-weight: 600;
//   transition: all 0.3s ease;
//   box-shadow: 0 8px 20px rgba(99, 102, 241, 0.3);
  
//   &:hover {
//     transform: translateY(-2px);
//     box-shadow: 0 12px 30px rgba(99, 102, 241, 0.4);
//   }
// `;

// const FilterPanel = styled.div`
//   position: fixed;
//   top: 0;
//   right: 0;
//   bottom: 0;
//   width: 380px;
//   max-width: 90%;
//   background: rgba(255, 255, 255, 0.95);
//   backdrop-filter: blur(20px);
//   padding: 2rem;
//   overflow-y: auto;
//   z-index: 1000;
//   box-shadow: -10px 0 30px rgba(0, 0, 0, 0.1);
//   transform: ${props => props.show ? 'translateX(0)' : 'translateX(100%)'};
//   transition: transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
//   border-left: 1px solid rgba(99, 102, 241, 0.1);
// `;

// const FilterHeader = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   margin-bottom: 2rem;
//   padding-bottom: 1rem;
//   border-bottom: 2px solid rgba(99, 102, 241, 0.1);
  
//   h2 {
//     font-size: 1.5rem;
//     font-weight: 700;
//     background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//     -webkit-background-clip: text;
//     -webkit-text-fill-color: transparent;
//     margin: 0;
//   }
// `;

// const CloseButton = styled.button`
//   padding: 0.75rem;
//   border-radius: 50%;
//   background: rgba(99, 102, 241, 0.1);
//   border: none;
//   cursor: pointer;
//   color: #667eea;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   transition: all 0.3s ease;
  
//   &:hover {
//     background: rgba(99, 102, 241, 0.2);
//     transform: scale(1.1);
//   }
// `;

// const FilterSection = styled.div`
//   margin-bottom: 2rem;
  
//   h3 {
//     font-size: 1.1rem;
//     font-weight: 700;
//     color: #1f2937;
//     margin-bottom: 1rem;
//     position: relative;
    
//     &:after {
//       content: '';
//       position: absolute;
//       bottom: -4px;
//       left: 0;
//       width: 40px;
//       height: 2px;
//       background: linear-gradient(90deg, #667eea, #764ba2);
//       border-radius: 2px;
//     }
//   }
// `;

// const ProductsGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
//   gap: 2rem;
//   animation: ${fadeInUp} 0.8s ease-out 0.4s both;
  
//   @media (max-width: 768px) {
//     grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
//     gap: 1.5rem;
//   }
// `;

// const ProductCard = styled.div`
//   background: rgba(255, 255, 255, 0.95);
//   border-radius: 24px;
//   overflow: hidden;
//   cursor: pointer;
//   transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
//   box-shadow: 
//     0 8px 25px rgba(0, 0, 0, 0.08),
//     0 0 0 1px rgba(255, 255, 255, 0.1);
//   backdrop-filter: blur(20px);
//   position: relative;
//   animation: ${scaleIn} 0.8s ease-out both;
//   animation-delay: ${props => (props.index * 0.1)}s;
  
//   &:before {
//     content: '';
//     position: absolute;
//     top: 0;
//     left: -100%;
//     width: 100%;
//     height: 100%;
//     background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
//     transition: left 0.8s ease;
//   }
  
//   &:hover {
//     transform: translateY(-12px) scale(1.02);
//     box-shadow: 
//       0 25px 50px rgba(0, 0, 0, 0.15),
//       0 0 0 1px rgba(99, 102, 241, 0.2);
    
//     &:before {
//       left: 100%;
//     }
//   }
// `;

// const ProductImageContainer = styled.div`
//   position: relative;
//   height: 280px;
//   overflow: hidden;
//   background: linear-gradient(135deg, #f8f9ff 0%, #e8f0ff 100%);
  
//   img {
//     width: 100%;
//     height: 100%;
//     object-fit: cover;
//     transition: transform 0.6s ease;
//   }
  
//   ${ProductCard}:hover & img {
//     transform: scale(1.1);
//   }
// `;

// const ProductBadges = styled.div`
//   position: absolute;
//   top: 1rem;
//   left: 1rem;
//   display: flex;
//   flex-direction: column;
//   gap: 0.5rem;
//   z-index: 2;
// `;

// const Badge = styled.span`
//   background: ${props => props.color || 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'};
//   color: white;
//   font-size: 0.8rem;
//   font-weight: 600;
//   padding: 0.5rem 0.75rem;
//   border-radius: 50px;
//   box-shadow: 0 4px 15px ${props => props.shadowColor || 'rgba(99, 102, 241, 0.4)'};
//   animation: ${pulse} 2s ease-in-out infinite;
//   display: flex;
//   align-items: center;
//   gap: 0.25rem;
// `;

// const ProductActions = styled.div`
//   position: absolute;
//   top: 1rem;
//   right: 1rem;
//   display: flex;
//   flex-direction: column;
//   gap: 0.5rem;
//   opacity: 0;
//   transform: translateX(20px);
//   transition: all 0.4s ease;
//   z-index: 2;
  
//   ${ProductCard}:hover & {
//     opacity: 1;
//     transform: translateX(0);
//   }
// `;

// const ActionButton = styled.button`
//   width: 44px;
//   height: 44px;
//   border-radius: 50%;
//   background: rgba(255, 255, 255, 0.95);
//   border: none;
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   transition: all 0.3s ease;
//   box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
//   backdrop-filter: blur(10px);
  
//   &:hover {
//     background: #667eea;
//     color: white;
//     transform: scale(1.1);
//     box-shadow: 0 6px 20px rgba(99, 102, 241, 0.4);
//   }
  
//   svg {
//     font-size: 1rem;
//     color: ${props => props.isActive ? '#e74c3c' : '#667eea'};
//   }
  
//   &:hover svg {
//     color: white;
//   }
// `;

// const ProductInfo = styled.div`
//   padding: 1.5rem;
// `;

// const ProductTitle = styled.h3`
//   font-size: 1.1rem;
//   font-weight: 700;
//   color: #1f2937;
//   margin: 0 0 0.5rem 0;
//   line-height: 1.4;
//   display: -webkit-box;
//   -webkit-line-clamp: 2;
//   -webkit-box-orient: vertical;
//   overflow: hidden;
// `;

// const ProductBrand = styled.p`
//   font-size: 0.85rem;
//   color: #667eea;
//   margin: 0 0 0.75rem 0;
//   font-weight: 600;
//   text-transform: uppercase;
//   letter-spacing: 0.5px;
// `;

// const ProductRating = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 0.5rem;
//   margin-bottom: 1rem;
  
//   .stars {
//     display: flex;
//     gap: 0.125rem;
//   }
  
//   .star {
//     color: #f59e0b;
//     font-size: 0.9rem;
//   }
  
//   .review-count {
//     font-size: 0.8rem;
//     color: #6b7280;
//     font-weight: 500;
//   }
// `;

// const ProductPricing = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   margin-bottom: 1rem;
  
//   .price-section {
//     display: flex;
//     align-items: baseline;
//     gap: 0.5rem;
//   }
  
//   .current-price {
//     font-size: 1.3rem;
//     font-weight: 800;
//     background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//     -webkit-background-clip: text;
//     -webkit-text-fill-color: transparent;
//   }
  
//   .original-price {
//     font-size: 1rem;
//     color: #9ca3af;
//     text-decoration: line-through;
//     font-weight: 500;
//   }
// `;

// const DiscountTag = styled.span`
//   background: linear-gradient(135deg, #10b981 0%, #059669 100%);
//   color: white;
//   font-size: 0.75rem;
//   font-weight: 600;
//   padding: 0.25rem 0.5rem;
//   border-radius: 12px;
//   display: flex;
//   align-items: center;
//   gap: 0.25rem;
// `;

// const LoadingContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   min-height: 60vh;
//   gap: 2rem;
//   color: #1f2937;
  
//   .spinner {
//     width: 60px;
//     height: 60px;
//     border: 4px solid rgba(99, 102, 241, 0.3);
//     border-top: 4px solid #667eea;
//     border-radius: 50%;
//     animation: ${spin} 1s linear infinite;
//   }
  
//   p {
//     font-size: 1.2rem;
//     font-weight: 600;
//   }
// `;

// const EmptyState = styled.div`
//   text-align: center;
//   padding: 4rem 2rem;
//   background: rgba(255, 255, 255, 0.95);
//   border-radius: 24px;
//   backdrop-filter: blur(20px);
//   box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
//   animation: ${fadeInUp} 0.8s ease-out;
  
//   .icon {
//     font-size: 4rem;
//     margin-bottom: 1.5rem;
//     animation: ${floatAnimation} 3s ease-in-out infinite;
//   }
  
//   h3 {
//     font-size: 1.5rem;
//     color: #1f2937;
//     margin-bottom: 1rem;
//   }
  
//   p {
//     color: #6b7280;
//     margin-bottom: 2rem;
//     font-size: 1.1rem;
//   }
// `;

// const ResetButton = styled.button`
//   padding: 1rem 2rem;
//   background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//   color: white;
//   border: none;
//   border-radius: 50px;
//   font-weight: 600;
//   font-size: 1.1rem;
//   cursor: pointer;
//   transition: all 0.3s ease;
//   box-shadow: 0 8px 20px rgba(99, 102, 241, 0.3);
  
//   &:hover {
//     transform: translateY(-3px);
//     box-shadow: 0 12px 30px rgba(99, 102, 241, 0.4);
//   }
// `;

// const ProductListing = () => {
//   const navigate = useNavigate();
//   const [products, setProducts] = useState([]);
//   const [filteredProducts, setFilteredProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedCategory, setSelectedCategory] = useState('all');
//   const [priceRange, setPriceRange] = useState([0, 5000]);
//   const [sortOption, setSortOption] = useState('featured');
//   const [searchTerm, setSearchTerm] = useState('');
//   const [viewMode, setViewMode] = useState('grid');
//   const [showFilters, setShowFilters] = useState(false);
//   const [selectedBrands, setSelectedBrands] = useState([]);
//   const [selectedColors, setSelectedColors] = useState([]);
//   const [selectedGender, setSelectedGender] = useState('all');
//   const [categories, setCategories] = useState([]);
//   const [allBrands, setAllBrands] = useState([]);
//   const [allColors, setAllColors] = useState([]);
//   const [wishlist, setWishlist] = useState([]);

//   // Fetch products from Firebase
//   useEffect(() => {
//     const productsRef = ref(db, 'Watch/admin/products');
//     const unsubscribe = onValue(productsRef, (snapshot) => {
//       const productsData = snapshot.val();
//       if (productsData) {
//         const productsList = Object.entries(productsData).map(([id, data]) => ({
//           id,
//           ...data,
//           price: parseFloat(data.price)
//         }));
//         setProducts(productsList);
        
//         // Extract unique categories
//         const uniqueCategories = [...new Set(productsList.map(p => p.category))];
//         setCategories(uniqueCategories);
        
//         // Extract unique brands
//         const uniqueBrands = [...new Set(productsList.map(p => p.brand?.toLowerCase()))].filter(Boolean);
//         setAllBrands(uniqueBrands);
        
//         // Extract unique colors
//         const uniqueColors = [...new Set(
//           productsList.flatMap(p => {
//             const colors = [];
//             if (Array.isArray(p.specifications?.colors)) {
//               colors.push(...p.specifications.colors.map(c => c?.toLowerCase()));
//             } else if (p.specifications?.color) {
//               colors.push(p.specifications.color?.toLowerCase());
//             }
//             return colors;
//           }).filter(Boolean)
//         )];
//         setAllColors(uniqueColors);
//       } else {
//         setProducts([]);
//         setCategories([]);
//         setAllBrands([]);
//         setAllColors([]);
//       }
//       setLoading(false);
//     });

//     return () => unsubscribe();
//   }, []);

//   // Apply filters
//   useEffect(() => {
//     let result = [...products];

//     // Apply filters
//     if (selectedCategory !== 'all') result = result.filter(p => p.category === selectedCategory);
//     result = result.filter(p => p.price >= priceRange[0] && p.price <= priceRange[1]);
//     if (searchTerm) {
//       const term = searchTerm.toLowerCase();
//       result = result.filter(p => 
//         p.name.toLowerCase().includes(term) ||
//         (p.brand && p.brand.toLowerCase().includes(term)) ||
//         p.description.toLowerCase().includes(term)
//       );
//     }
//     if (selectedBrands.length > 0) {
//       result = result.filter(p => p.brand && selectedBrands.includes(p.brand.toLowerCase()));
//     }
//     if (selectedColors.length > 0) {
//       result = result.filter(p => {
//         const productColors = [];
//         if (Array.isArray(p.specifications?.colors)) {
//           productColors.push(...p.specifications.colors.map(c => c?.toLowerCase()));
//         } else if (p.specifications?.color) {
//           productColors.push(p.specifications.color?.toLowerCase());
//         }
//         return productColors.some(color => selectedColors.includes(color));
//       });
//     }
//     if (selectedGender !== 'all' && selectedCategory !== 'Clocks') {
//       result = result.filter(p => p.specifications?.gender === selectedGender);
//     }

//     // Apply sorting
//     switch (sortOption) {
//       case 'price-low': result.sort((a, b) => a.price - b.price); break;
//       case 'price-high': result.sort((a, b) => b.price - a.price); break;
//       case 'newest': result.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)); break;
//       case 'featured': result.sort((a, b) => (b.featured ? 1 : 0) - (a.featured ? 1 : 0)); break;
//       case 'discount': result.sort((a, b) => (b.discount || 0) - (a.discount || 0)); break;
//       default: break;
//     }

//     setFilteredProducts(result);
//   }, [products, selectedCategory, priceRange, sortOption, searchTerm, selectedBrands, selectedColors, selectedGender]);

//   // Helper functions
//   const getColorValue = (colorName) => {
//     const colorMap = {
//       'black': '#1a1a1a',
//       'white': '#ffffff',
//       'red': '#e74c3c',
//       'blue': '#3498db',
//       'green': '#27ae60',
//       'yellow': '#f1c40f',
//       'silver': '#bdc3c7',
//       'gold': '#f39c12',
//       'rose gold': '#e8b4b8',
//       'navy': '#2c3e50',
//       'brown': '#8b4513',
//       'gray': '#7f8c8d',
//       'grey': '#7f8c8d',
//       'pink': '#e91e63',
//       'purple': '#9b59b6',
//       'orange': '#e67e22',
//       'beige': '#f5f5dc',
//       'teal': '#1abc9c',
//       'burgundy': '#8e2a2a'
//     };
//     return colorMap[colorName?.toLowerCase()] || colorName;
//   };

//   const toggleWishlist = (productId, e) => {
//     e.stopPropagation();
//     setWishlist(prev => 
//       prev.includes(productId) 
//         ? prev.filter(id => id !== productId) 
//         : [...prev, productId]
//     );
//   };

//   const toggleBrand = (brand) => {
//     setSelectedBrands(prev => 
//       prev.includes(brand) 
//         ? prev.filter(b => b !== brand) 
//         : [...prev, brand]
//     );
//   };

//   const toggleColor = (color) => {
//     setSelectedColors(prev => 
//       prev.includes(color) 
//         ? prev.filter(c => c !== color) 
//         : [...prev, color]
//     );
//   };

//   const handlePriceChange = (e, index) => {
//     const newValue = parseInt(e.target.value);
//     const newRange = [...priceRange];
//     newRange[index] = newValue;
//     setPriceRange(newRange);
//   };

//   const viewProductDetail = (productId) => {
//     navigate(`/product/${productId}`);
//   };


  

//   const renderRating = (rating) => {
//     return Array(5).fill(0).map((_, i) => (
//       <BsStarFill 
//         key={i} 
//         className="star"
//         style={{ 
//           color: i < (rating || 0) ? '#f59e0b' : '#e5e7eb'
//         }} 
//       />
//     ));
//   };

//   const resetFilters = () => {
//     setSelectedCategory('all');
//     setPriceRange([0, 5000]);
//     setSearchTerm('');
//     setSelectedBrands([]);
//     setSelectedColors([]);
//     setSelectedGender('all');
//   };

//   return (
//     <>
//       <Navbar />
//       <PageContainer>
//         <MainContent>
//           <PageHeader>
//             <PageTitle>
//               {selectedCategory === 'all' ? 'Our Premium Collection' : `${selectedCategory}`}
//             </PageTitle>
            
//             <ControlsContainer>
//               <SearchContainer>
//                 <FaSearch className="search-icon" />
//                 <SearchInput
//                   type="text"
//                   placeholder="Search for products, brands, or categories..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                 />
//               </SearchContainer>
              
//               <SecondaryControls>
//                 <ViewToggle>
//                   <ViewButton
//                     active={viewMode === 'grid'}
//                     onClick={() => setViewMode('grid')}
//                   >
//                     <BsGridFill />
//                   </ViewButton>
//                 </ViewToggle>
                
//                 <SortSelect>
//                   <select
//                     value={sortOption}
//                     onChange={(e) => setSortOption(e.target.value)}
//                   >
//                     <option value="featured">✨ Featured</option>
//                     <option value="price-low">💰 Price: Low to High</option>
//                     <option value="price-high">💎 Price: High to Low</option>
//                     <option value="newest">🆕 Newest Arrivals</option>
//                     <option value="discount">🔥 Best Discounts</option>
//                   </select>
//                   <BsChevronDown className="dropdown-icon" />
//                 </SortSelect>
                
//                 <FilterButton onClick={() => setShowFilters(true)}>
//                   <FaFilter />
//                   Filters
//                 </FilterButton>
//               </SecondaryControls>
//             </ControlsContainer>
//           </PageHeader>

//           {/* Filter Panel */}
//           <FilterPanel show={showFilters}>
//             <FilterHeader>
//               <h2>🎯 Filter Products</h2>
//               <CloseButton onClick={() => setShowFilters(false)}>
//                 <FaTimes />
//               </CloseButton>
//             </FilterHeader>
            
//             {/* Category Filter */}
//             <FilterSection>
//               <h3>📂 Categories</h3>
//               <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                 <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem', borderRadius: '8px', cursor: 'pointer' }}>
//                   <input
//                     type="radio"
//                     name="category"
//                     checked={selectedCategory === 'all'}
//                     onChange={() => setSelectedCategory('all')}
//                     style={{ accentColor: '#667eea' }}
//                   />
//                   <span>All Products</span>
//                 </label>
//                 {categories.map(category => (
//                   <label key={category} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem', borderRadius: '8px', cursor: 'pointer' }}>
//                     <input
//                       type="radio"
//                       name="category"
//                       checked={selectedCategory === category}
//                       onChange={() => setSelectedCategory(category)}
//                       style={{ accentColor: '#667eea' }}
//                     />
//                     <span>{category}</span>
//                   </label>
//                 ))}
//               </div>
//             </FilterSection>
            
//             {/* Price Filter */}
//             <FilterSection>
//               <h3>💰 Price Range</h3>
//               <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
//                 <div style={{ display: 'flex', gap: '0.5rem' }}>
//                   <input
//                     type="number"
//                     value={priceRange[0]}
//                     onChange={(e) => handlePriceChange(e, 0)}
//                     min="0"
//                     max={priceRange[1]}
//                     style={{ 
//                       flex: 1, 
//                       padding: '0.5rem', 
//                       border: '2px solid rgba(99, 102, 241, 0.2)', 
//                       borderRadius: '8px', 
//                       outline: 'none' 
//                     }}
//                   />
//                   <span style={{ display: 'flex', alignItems: 'center' }}>to</span>
//                   <input
//                     type="number"
//                     value={priceRange[1]}
//                     onChange={(e) => handlePriceChange(e, 1)}
//                     min={priceRange[0]}
//                     max="10000"
//                     style={{ 
//                       flex: 1, 
//                       padding: '0.5rem', 
//                       border: '2px solid rgba(99, 102, 241, 0.2)', 
//                       borderRadius: '8px', 
//                       outline: 'none' 
//                     }}
//                   />
//                 </div>
//                 <p style={{ textAlign: 'center', color: '#6b7280' }}>
//                   ₹{priceRange[0]} - ₹{priceRange[1]}
//                 </p>
//               </div>
//             </FilterSection>

//             {/* Brand Filter */}
//             {allBrands.length > 0 && (
//               <FilterSection>
//                 <h3>🏷️ Brands</h3>
//                 <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', maxHeight: '200px', overflowY: 'auto' }}>
//                   {allBrands.map(brand => (
//                     <label key={brand} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem', borderRadius: '8px', cursor: 'pointer' }}>
//                       <input
//                         type="checkbox"
//                         checked={selectedBrands.includes(brand)}
//                         onChange={() => toggleBrand(brand)}
//                         style={{ accentColor: '#667eea' }}
//                       />
//                       <span>{brand.charAt(0).toUpperCase() + brand.slice(1)}</span>
//                     </label>
//                   ))}
//                 </div>
//               </FilterSection>
//             )}

//             {/* Color Filter */}
//             {allColors.length > 0 && (
//               <FilterSection>
//                 <h3>🎨 Colors</h3>
//                 <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
//                   {allColors.map(color => {
//                     const colorValue = getColorValue(color);
//                     return (
//                       <div 
//                         key={color}
//                         onClick={() => toggleColor(color)}
//                         style={{
//                           width: '36px',
//                           height: '36px',
//                           borderRadius: '50%',
//                           backgroundColor: colorValue,
//                           border: selectedColors.includes(color) 
//                             ? '3px solid #667eea' 
//                             : '3px solid #e5e7eb',
//                           cursor: 'pointer',
//                           boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
//                           position: 'relative',
//                           transition: 'all 0.3s ease'
//                         }}
//                         title={color.charAt(0).toUpperCase() + color.slice(1)}
//                       >
//                         {selectedColors.includes(color) && (
//                           <div style={{
//                             position: 'absolute',
//                             top: '50%',
//                             left: '50%',
//                             transform: 'translate(-50%, -50%)',
//                             color: colorValue === '#ffffff' ? '#667eea' : 'white',
//                             fontSize: '14px',
//                             fontWeight: 'bold'
//                           }}>
//                             ✓
//                           </div>
//                         )}
//                       </div>
//                     );
//                   })}
//                 </div>
//               </FilterSection>
//             )}
            
//             <ResetButton
//               onClick={() => {
//                 resetFilters();
//                 setShowFilters(false);
//               }}
//               style={{ width: '100%', marginTop: '1rem' }}
//             >
//               🔄 Reset & Apply
//             </ResetButton>
//           </FilterPanel>

//           {/* Products Listing */}
//           {loading ? (
//             <LoadingContainer>
//               <div className="spinner"></div>
//               <p>Loading amazing products...</p>
//             </LoadingContainer>
//           ) : filteredProducts.length === 0 ? (
//             <EmptyState>
//               <div className="icon">🔍</div>
//               <h3>No Products Found</h3>
//               <p>Try adjusting your filters or search term to find what you're looking for.</p>
//               <ResetButton onClick={resetFilters}>
//                 <HiOutlineSparkles style={{ marginRight: '0.5rem' }} />
//                 Reset Filters
//               </ResetButton>
//             </EmptyState>
//           ) : (
//             <ProductsGrid>
//               {filteredProducts.map((product, index) => (
//                 <ProductCard 
//                   key={product.id} 
//                   index={index}
//                   onClick={() => viewProductDetail(product.id)}
//                 >
//                   <ProductImageContainer>
//                     <img
//                       src={product.images?.[0] || '/placeholder-product.jpg'}
//                       alt={product.name}
//                       onError={(e) => {
//                         e.target.src = '/placeholder-product.jpg';
//                       }}
//                     />
                    
//                     <ProductBadges>
//                       {product.featured && (
//                         <Badge color="linear-gradient(135deg, #f59e0b 0%, #d97706 100%)" shadowColor="rgba(245, 158, 11, 0.4)">
//                           <HiOutlineSparkles /> Featured
//                         </Badge>
//                       )}
//                       {product.discount > 0 && (
//                         <Badge color="linear-gradient(135deg, #ef4444 0%, #dc2626 100%)" shadowColor="rgba(239, 68, 68, 0.4)">
//                           <HiOutlineFire /> {product.discount}% OFF
//                         </Badge>
//                       )}
//                     </ProductBadges>
                    
//                     <ProductActions>
//                       {/* <ActionButton
//                         isActive={wishlist.includes(product.id)}
//                         onClick={(e) => toggleWishlist(product.id, e)}
//                         title="Add to Wishlist"
//                       >
//                         {wishlist.includes(product.id) ? <FaHeart /> : <FaRegHeart />}
//                       </ActionButton> */}
//                       <ActionButton
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           viewProductDetail(product.id);
//                         }}
//                         title="Quick View"
//                       >
//                         <FaEye />
//                       </ActionButton>
//                       {/* <ActionButton
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           alert(`${product.name} added to cart!`);
//                         }}
//                         title="Add to Cart"
//                       >
//                         <FaShoppingCart />
//                       </ActionButton> */}
//                     </ProductActions>
//                   </ProductImageContainer>
                  
//                   <ProductInfo>
//                     <ProductTitle>{product.name}</ProductTitle>
//                     <ProductBrand>{product.brand}</ProductBrand>
                    
//                     <ProductRating>
//                       <div className="stars">
//                         {renderRating(product.rating || 4)}
//                       </div>
//                       <span className="review-count">
//                         ({product.reviewCount || Math.floor(Math.random() * 50) + 10})
//                       </span>
//                     </ProductRating>
                    
//                     <ProductPricing>
//                       <div className="price-section">
//                         <span className="current-price">
//                           ₹{(product.price * (1 - (product.discount || 0) / 100)).toFixed(0)}
//                         </span>
//                         {product.discount > 0 && (
//                           <span className="original-price">
//                             ₹{product.price.toFixed(0)}
//                           </span>
//                         )}
//                       </div>
//                       {product.discount > 0 && (
//                         <DiscountTag>
//                           <FaTag /> Save ₹{(product.price * product.discount / 100).toFixed(0)}
//                         </DiscountTag>
//                       )}
//                     </ProductPricing>
//                   </ProductInfo>
//                 </ProductCard>
//               ))}
//             </ProductsGrid>
//           )}
//         </MainContent>
//       </PageContainer>
//       <Footer />
//     </>
//   );
// };

// export default ProductListing;




import React, { useState, useEffect } from 'react';
import { db, ref } from '../firebase';
import { onValue } from 'firebase/database';
import Footer from './Footer';
import { useNavigate } from 'react-router-dom';
import { 
  FaStar, 
  FaRegStar, 
  FaSearch, 
  FaFilter, 
  FaTimes, 
  FaShoppingCart,
  FaHeart,
  FaRegHeart,
  FaEye,
  FaTag,
  FaGift,
  FaShieldAlt,
  FaTruck
} from 'react-icons/fa';
import { BsGridFill, BsList, BsChevronDown, BsStarFill } from 'react-icons/bs';
import { HiOutlineSparkles, HiOutlineFire } from 'react-icons/hi';
import styled, { keyframes } from 'styled-components';
import Navbar from './Navbar';

// Enhanced Keyframe Animations
const slideInFromLeft = keyframes`
  from {
    transform: translateX(-50px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const slideInFromRight = keyframes`
  from {
    transform: translateX(50px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const fadeInUp = keyframes`
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const fadeInDown = keyframes`
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const scaleIn = keyframes`
  from {
    transform: scale(0.9);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
`;

const pulse = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
`;

const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

const floatAnimation = keyframes`
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-8px); }
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const sparkle = keyframes`
  0%, 100% { opacity: 0; transform: scale(0.8) rotate(0deg); }
  50% { opacity: 1; transform: scale(1) rotate(180deg); }
`;

// Enhanced Styled Components
const PageContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  position: relative;
  overflow: hidden;
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: 
      radial-gradient(circle at 20% 50%, rgba(99, 102, 241, 0.03) 0%, transparent 50%),
      radial-gradient(circle at 80% 20%, rgba(236, 72, 153, 0.03) 0%, transparent 50%),
      radial-gradient(circle at 40% 80%, rgba(14, 165, 233, 0.03) 0%, transparent 50%);
    animation: ${floatAnimation} 20s ease-in-out infinite;
  }
`;

const MainContent = styled.div`
  position: relative;
  z-index: 1;
  padding: 2rem;
  max-width: 1600px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const PageHeader = styled.div`
  margin-bottom: 3rem;
  animation: ${fadeInDown} 0.8s ease-out;
`;

const PageTitle = styled.h1`
  font-size: 3rem;
  font-weight: 800;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0 0 1rem 0;
  line-height: 1.2;
  position: relative;
  
  &:after {
    content: '✨';
    position: absolute;
    top: -10px;
    right: -40px;
    font-size: 2rem;
    animation: ${sparkle} 2s ease-in-out infinite;
  }
  
  @media (max-width: 768px) {
    font-size: 2.2rem;
    
    &:after {
      right: -30px;
      font-size: 1.5rem;
    }
  }
`;

const ControlsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  animation: ${fadeInUp} 0.8s ease-out 0.2s both;
`;

const SearchContainer = styled.div`
  position: relative;
  max-width: 600px;
  
  .search-icon {
    position: absolute;
    top: 50%;
    left: 1.25rem;
    transform: translateY(-50%);
    color: #667eea;
    font-size: 1.1rem;
  }
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 1rem 1.25rem 1rem 3rem;
  border: 2px solid rgba(99, 102, 241, 0.2);
  border-radius: 50px;
  background: rgba(255, 255, 255, 0.9);
  font-size: 1rem;
  outline: none;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 15px rgba(99, 102, 241, 0.1);
  
  &:focus {
    border-color: #667eea;
    box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.1);
    background: white;
  }
  
  &::placeholder {
    color: #9ca3af;
  }
`;

const SecondaryControls = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  
  @media (max-width: 768px) {
    justify-content: space-between;
  }
`;

const ViewToggle = styled.div`
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50px;
  padding: 0.5rem;
  box-shadow: 0 4px 15px rgba(99, 102, 241, 0.1);
  backdrop-filter: blur(10px);
  border: 2px solid rgba(99, 102, 241, 0.1);
`;

const ViewButton = styled.button`
  padding: 0.75rem;
  border-radius: 50px;
  background: ${props => props.active ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'transparent'};
  color: ${props => props.active ? 'white' : '#64748b'};
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  
  &:hover {
    background: ${props => props.active ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'rgba(99, 102, 241, 0.1)'};
    color: ${props => props.active ? 'white' : '#667eea'};
  }
`;

const SortSelect = styled.div`
  position: relative;
  
  select {
    padding: 0.875rem 2.5rem 0.875rem 1.25rem;
    border: 2px solid rgba(99, 102, 241, 0.2);
    border-radius: 50px;
    background: rgba(255, 255, 255, 0.9);
    font-size: 1rem;
    appearance: none;
    outline: none;
    cursor: pointer;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
    box-shadow: 0 4px 15px rgba(99, 102, 241, 0.1);
    min-width: 200px;
    
    &:focus {
      border-color: #667eea;
      box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.1);
    }
  }
  
  .dropdown-icon {
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    color: #667eea;
  }
`;

const FilterButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.875rem 1.5rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 50px;
  color: white;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 8px 20px rgba(99, 102, 241, 0.3);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 30px rgba(99, 102, 241, 0.4);
  }
`;

const FilterPanel = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 380px;
  max-width: 90%;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  padding: 2rem;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: -10px 0 30px rgba(0, 0, 0, 0.1);
  transform: ${props => props.show ? 'translateX(0)' : 'translateX(100%)'};
  transition: transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  border-left: 1px solid rgba(99, 102, 241, 0.1);
`;

const FilterHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid rgba(99, 102, 241, 0.1);
  
  h2 {
    font-size: 1.5rem;
    font-weight: 700;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin: 0;
  }
`;

const CloseButton = styled.button`
  padding: 0.75rem;
  border-radius: 50%;
  background: rgba(99, 102, 241, 0.1);
  border: none;
  cursor: pointer;
  color: #667eea;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  
  svg {
    font-size: 1.2rem;
    color: #667eea;
  }
  
  &:hover {
    background: rgba(99, 102, 241, 0.2);
    transform: scale(1.1);
    
    svg {
      color: #764ba2;
    }
  }
  
  &:active {
    transform: scale(0.95);
  }
`;


const FilterSection = styled.div`
  margin-bottom: 2rem;
  
  h3 {
    font-size: 1.1rem;
    font-weight: 700;
    color: #1f2937;
    margin-bottom: 1rem;
    position: relative;
    
    &:after {
      content: '';
      position: absolute;
      bottom: -4px;
      left: 0;
      width: 40px;
      height: 2px;
      background: linear-gradient(90deg, #667eea, #764ba2);
      border-radius: 2px;
    }
  }
`;

// Modified ProductsGrid for 2-column mobile layout
const ProductsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 2rem;
  animation: ${fadeInUp} 0.8s ease-out 0.4s both;
  
  /* Tablet: 3 columns */
  @media (max-width: 1024px) and (min-width: 769px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 1.5rem;
  }
  
  /* Mobile: 2 equal columns */
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
  
  /* Small mobile: Still 2 columns */
  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
  }
  
  /* Extra small mobile: Still 2 columns */
  @media (max-width: 360px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem;
  }
`;

const ProductCard = styled.div`
  background: rgba(255, 255, 255, 0.95);
  border-radius: 24px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  box-shadow: 
    0 8px 25px rgba(0, 0, 0, 0.08),
    0 0 0 1px rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  position: relative;
  animation: ${scaleIn} 0.8s ease-out both;
  animation-delay: ${props => (props.index * 0.1)}s;
  width: 100%;
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
    transition: left 0.8s ease;
  }
  
  &:hover {
    transform: translateY(-12px) scale(1.02);
    box-shadow: 
      0 25px 50px rgba(0, 0, 0, 0.15),
      0 0 0 1px rgba(99, 102, 241, 0.2);
    
    &:before {
      left: 100%;
    }
  }
  
  /* Mobile adjustments */
  @media (max-width: 768px) {
    border-radius: 16px;
    
    &:hover {
      transform: translateY(-6px) scale(1.01);
    }
  }
  
  @media (max-width: 480px) {
    border-radius: 12px;
  }
`;

const ProductImageContainer = styled.div`
  position: relative;
  height: 280px;
  overflow: hidden;
  background: linear-gradient(135deg, #f8f9ff 0%, #e8f0ff 100%);
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.6s ease;
  }
  
  ${ProductCard}:hover & img {
    transform: scale(1.1);
  }
  
  /* Mobile adjustments */
  @media (max-width: 768px) {
    height: 200px;
  }
  
  @media (max-width: 480px) {
    height: 180px;
  }
  
  @media (max-width: 360px) {
    height: 150px;
  }
`;

const ProductBadges = styled.div`
  position: absolute;
  top: 1rem;
  left: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  z-index: 2;
  
  @media (max-width: 768px) {
    top: 0.5rem;
    left: 0.5rem;
    gap: 0.3rem;
  }
`;

const Badge = styled.span`
  background: ${props => props.color || 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'};
  color: white;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 0.5rem 0.75rem;
  border-radius: 50px;
  box-shadow: 0 4px 15px ${props => props.shadowColor || 'rgba(99, 102, 241, 0.4)'};
  animation: ${pulse} 2s ease-in-out infinite;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  
  @media (max-width: 768px) {
    font-size: 0.7rem;
    padding: 0.35rem 0.6rem;
  }
  
  @media (max-width: 480px) {
    font-size: 0.65rem;
    padding: 0.3rem 0.5rem;
  }
`;

const ProductActions = styled.div`
  position: absolute;
  top: 1rem;
  right: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  opacity: 0;
  transform: translateX(20px);
  transition: all 0.4s ease;
  z-index: 2;
  
  ${ProductCard}:hover & {
    opacity: 1;
    transform: translateX(0);
  }
  
  @media (max-width: 768px) {
    opacity: 1;
    transform: translateX(0);
    top: 0.5rem;
    right: 0.5rem;
    gap: 0.3rem;
  }
`;

const ActionButton = styled.button`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.95);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  
  &:hover {
    background: #667eea;
    color: white;
    transform: scale(1.1);
    box-shadow: 0 6px 20px rgba(99, 102, 241, 0.4);
  }
  
  svg {
    font-size: 1rem;
    color: ${props => props.isActive ? '#e74c3c' : '#667eea'};
  }
  
  &:hover svg {
    color: white;
  }
  
  @media (max-width: 768px) {
    width: 36px;
    height: 36px;
    
    svg {
      font-size: 0.9rem;
    }
  }
  
  @media (max-width: 480px) {
    width: 32px;
    height: 32px;
    
    svg {
      font-size: 0.8rem;
    }
  }
`;

const ProductInfo = styled.div`
  padding: 1.5rem;
  
  @media (max-width: 768px) {
    padding: 1rem;
  }
  
  @media (max-width: 480px) {
    padding: 0.75rem;
  }
`;

const ProductTitle = styled.h3`
  font-size: 1.1rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 0.5rem 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  
  @media (max-width: 768px) {
    font-size: 0.95rem;
    -webkit-line-clamp: 2;
  }
  
  @media (max-width: 480px) {
    font-size: 0.85rem;
    line-height: 1.3;
  }
`;

const ProductBrand = styled.p`
  font-size: 0.85rem;
  color: #667eea;
  margin: 0 0 0.75rem 0;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  
  @media (max-width: 768px) {
    font-size: 0.75rem;
    margin: 0 0 0.5rem 0;
  }
  
  @media (max-width: 480px) {
    font-size: 0.7rem;
  }
`;

const ProductRating = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  
  .stars {
    display: flex;
    gap: 0.125rem;
  }
  
  .star {
    color: #f59e0b;
    font-size: 0.9rem;
  }
  
  .review-count {
    font-size: 0.8rem;
    color: #6b7280;
    font-weight: 500;
  }
  
  @media (max-width: 768px) {
    margin-bottom: 0.75rem;
    
    .star {
      font-size: 0.8rem;
    }
    
    .review-count {
      font-size: 0.7rem;
    }
  }
  
  @media (max-width: 480px) {
    margin-bottom: 0.5rem;
    gap: 0.3rem;
    
    .star {
      font-size: 0.7rem;
    }
    
    .review-count {
      font-size: 0.65rem;
    }
  }
`;

const ProductPricing = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
  flex-wrap: wrap;
  gap: 0.5rem;
  
  .price-section {
    display: flex;
    align-items: baseline;
    gap: 0.5rem;
    flex-wrap: wrap;
  }
  
  .current-price {
    font-size: 1.3rem;
    font-weight: 800;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  
  .original-price {
    font-size: 1rem;
    color: #9ca3af;
    text-decoration: line-through;
    font-weight: 500;
  }
  
  @media (max-width: 768px) {
    margin-bottom: 0.75rem;
    
    .current-price {
      font-size: 1.1rem;
    }
    
    .original-price {
      font-size: 0.85rem;
    }
  }
  
  @media (max-width: 480px) {
    margin-bottom: 0.5rem;
    gap: 0.3rem;
    
    .price-section {
      gap: 0.3rem;
    }
    
    .current-price {
      font-size: 1rem;
    }
    
    .original-price {
      font-size: 0.75rem;
    }
  }
`;

const DiscountTag = styled.span`
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  
  @media (max-width: 768px) {
    font-size: 0.7rem;
    padding: 0.2rem 0.4rem;
  }
  
  @media (max-width: 480px) {
    font-size: 0.65rem;
    padding: 0.15rem 0.35rem;
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  gap: 2rem;
  color: #1f2937;
  
  .spinner {
    width: 60px;
    height: 60px;
    border: 4px solid rgba(99, 102, 241, 0.3);
    border-top: 4px solid #667eea;
    border-radius: 50%;
    animation: ${spin} 1s linear infinite;
  }
  
  p {
    font-size: 1.2rem;
    font-weight: 600;
  }
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 4rem 2rem;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 24px;
  backdrop-filter: blur(20px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  animation: ${fadeInUp} 0.8s ease-out;
  
  .icon {
    font-size: 4rem;
    margin-bottom: 1.5rem;
    animation: ${floatAnimation} 3s ease-in-out infinite;
  }
  
  h3 {
    font-size: 1.5rem;
    color: #1f2937;
    margin-bottom: 1rem;
  }
  
  p {
    color: #6b7280;
    margin-bottom: 2rem;
    font-size: 1.1rem;
  }
`;

const ResetButton = styled.button`
  padding: 1rem 2rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 50px;
  font-weight: 600;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 8px 20px rgba(99, 102, 241, 0.3);
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 30px rgba(99, 102, 241, 0.4);
  }
`;

const ProductListing = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [priceRange, setPriceRange] = useState([0, 5000]);
  const [sortOption, setSortOption] = useState('featured');
  const [searchTerm, setSearchTerm] = useState('');
  const [viewMode, setViewMode] = useState('grid');
  const [showFilters, setShowFilters] = useState(false);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedColors, setSelectedColors] = useState([]);
  const [selectedGenders, setSelectedGenders] = useState([]); // NEW: Gender filter
  const [selectedMaterials, setSelectedMaterials] = useState([]); // NEW: Material filter
  const [categories, setCategories] = useState([]);
  const [allBrands, setAllBrands] = useState([]);
  const [allColors, setAllColors] = useState([]);
  const [allGenders, setAllGenders] = useState([]); // NEW: All available genders
  const [allMaterials, setAllMaterials] = useState([]); // NEW: All available materials
  const [wishlist, setWishlist] = useState([]);

  // Fetch products from Firebase
// Fetch products from Firebase
useEffect(() => {
  const productsRef = ref(db, 'Watch/admin/products');
  const unsubscribe = onValue(productsRef, (snapshot) => {
    const productsData = snapshot.val();
    if (productsData) {
      const productsList = Object.entries(productsData).map(([id, data]) => ({
        id,
        ...data,
        price: parseFloat(data.price)
      }));
      setProducts(productsList);
      
      // Extract unique categories
      const uniqueCategories = [...new Set(productsList.map(p => p.category))];
      setCategories(uniqueCategories);
      
      // Extract unique brands
      const uniqueBrands = [...new Set(productsList.map(p => p.brand?.toLowerCase()))].filter(Boolean);
      setAllBrands(uniqueBrands);
      
      // Extract unique colors
      const uniqueColors = [...new Set(
        productsList.flatMap(p => {
          const colors = [];
          if (Array.isArray(p.specifications?.colors)) {
            colors.push(...p.specifications.colors.map(c => c?.toLowerCase()));
          } else if (p.specifications?.color) {
            colors.push(p.specifications.color?.toLowerCase());
          }
          return colors;
        }).filter(Boolean)
      )];
      setAllColors(uniqueColors);
      
      // FIXED: Extract unique genders with proper type checking
      const uniqueGenders = [...new Set(
        productsList
          .map(p => {
            const gender = p.specifications?.gender;
            // Check if gender exists and is a string
            if (gender && typeof gender === 'string') {
              return gender.toLowerCase();
            }
            return null;
          })
          .filter(Boolean)
      )];
      setAllGenders(uniqueGenders);
      
      // FIXED: Extract unique materials with proper type checking
      const uniqueMaterials = [...new Set(
        productsList.flatMap(p => {
          const materials = [];
          
          // Check if materials is an array
          if (Array.isArray(p.specifications?.materials)) {
            materials.push(
              ...p.specifications.materials
                .filter(m => m && typeof m === 'string') // Only process strings
                .map(m => m.toLowerCase())
            );
          } 
          // Check if material is a single string value
          else if (p.specifications?.material && typeof p.specifications.material === 'string') {
            materials.push(p.specifications.material.toLowerCase());
          }
          
          return materials;
        }).filter(Boolean)
      )];
      setAllMaterials(uniqueMaterials);
    } else {
      setProducts([]);
      setCategories([]);
      setAllBrands([]);
      setAllColors([]);
      setAllGenders([]);
      setAllMaterials([]);
    }
    setLoading(false);
  });

  return () => unsubscribe();
}, []);

// FIXED: Apply filters with proper type checking
useEffect(() => {
  let result = [...products];

  // Apply filters
  if (selectedCategory !== 'all') result = result.filter(p => p.category === selectedCategory);
  result = result.filter(p => p.price >= priceRange[0] && p.price <= priceRange[1]);
  
  if (searchTerm) {
    const term = searchTerm.toLowerCase();
    result = result.filter(p => 
      p.name.toLowerCase().includes(term) ||
      (p.brand && p.brand.toLowerCase().includes(term)) ||
      p.description.toLowerCase().includes(term)
    );
  }
  
  if (selectedBrands.length > 0) {
    result = result.filter(p => p.brand && selectedBrands.includes(p.brand.toLowerCase()));
  }
  
  if (selectedColors.length > 0) {
    result = result.filter(p => {
      const productColors = [];
      if (Array.isArray(p.specifications?.colors)) {
        productColors.push(...p.specifications.colors.map(c => c?.toLowerCase()));
      } else if (p.specifications?.color) {
        productColors.push(p.specifications.color?.toLowerCase());
      }
      return productColors.some(color => selectedColors.includes(color));
    });
  }
  
  // FIXED: Gender filter with type checking
  if (selectedGenders.length > 0) {
    result = result.filter(p => {
      const gender = p.specifications?.gender;
      // Ensure gender is a string before comparing
      return gender && typeof gender === 'string' && selectedGenders.includes(gender.toLowerCase());
    });
  }
  
  // FIXED: Material filter with type checking
  if (selectedMaterials.length > 0) {
    result = result.filter(p => {
      const productMaterials = [];
      
      // Check if materials is an array
      if (Array.isArray(p.specifications?.materials)) {
        productMaterials.push(
          ...p.specifications.materials
            .filter(m => m && typeof m === 'string') // Only process strings
            .map(m => m.toLowerCase())
        );
      } 
      // Check if material is a single string value
      else if (p.specifications?.material && typeof p.specifications.material === 'string') {
        productMaterials.push(p.specifications.material.toLowerCase());
      }
      
      return productMaterials.some(material => selectedMaterials.includes(material));
    });
  }

  // Apply sorting
  switch (sortOption) {
    case 'price-low': result.sort((a, b) => a.price - b.price); break;
    case 'price-high': result.sort((a, b) => b.price - a.price); break;
    case 'newest': result.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)); break;
    case 'featured': result.sort((a, b) => (b.featured ? 1 : 0) - (a.featured ? 1 : 0)); break;
    case 'discount': result.sort((a, b) => (b.discount || 0) - (a.discount || 0)); break;
    default: break;
  }

  setFilteredProducts(result);
}, [products, selectedCategory, priceRange, sortOption, searchTerm, selectedBrands, selectedColors, selectedGenders, selectedMaterials]);


  // Helper functions
  const getColorValue = (colorName) => {
    const colorMap = {
      'black': '#1a1a1a',
      'white': '#ffffff',
      'red': '#e74c3c',
      'blue': '#3498db',
      'green': '#27ae60',
      'yellow': '#f1c40f',
      'silver': '#bdc3c7',
      'gold': '#f39c12',
      'rose gold': '#e8b4b8',
      'navy': '#2c3e50',
      'brown': '#8b4513',
      'gray': '#7f8c8d',
      'grey': '#7f8c8d',
      'pink': '#e91e63',
      'purple': '#9b59b6',
      'orange': '#e67e22',
      'beige': '#f5f5dc',
      'teal': '#1abc9c',
      'burgundy': '#8e2a2a'
    };
    return colorMap[colorName?.toLowerCase()] || colorName;
  };

  const toggleWishlist = (productId, e) => {
    e.stopPropagation();
    setWishlist(prev => 
      prev.includes(productId) 
        ? prev.filter(id => id !== productId) 
        : [...prev, productId]
    );
  };

  const toggleBrand = (brand) => {
    setSelectedBrands(prev => 
      prev.includes(brand) 
        ? prev.filter(b => b !== brand) 
        : [...prev, brand]
    );
  };

  const toggleColor = (color) => {
    setSelectedColors(prev => 
      prev.includes(color) 
        ? prev.filter(c => c !== color) 
        : [...prev, color]
    );
  };

  // NEW: Toggle gender
  const toggleGender = (gender) => {
    setSelectedGenders(prev => 
      prev.includes(gender) 
        ? prev.filter(g => g !== gender) 
        : [...prev, gender]
    );
  };

  // NEW: Toggle material
  const toggleMaterial = (material) => {
    setSelectedMaterials(prev => 
      prev.includes(material) 
        ? prev.filter(m => m !== material) 
        : [...prev, material]
    );
  };

  const handlePriceChange = (e, index) => {
    const newValue = parseInt(e.target.value);
    const newRange = [...priceRange];
    newRange[index] = newValue;
    setPriceRange(newRange);
  };

  const viewProductDetail = (productId) => {
    navigate(`/product/${productId}`);
  };

  const renderRating = (rating) => {
    return Array(5).fill(0).map((_, i) => (
      <BsStarFill 
        key={i} 
        className="star"
        style={{ 
          color: i < (rating || 0) ? '#f59e0b' : '#e5e7eb'
        }} 
      />
    ));
  };

  const resetFilters = () => {
    setSelectedCategory('all');
    setPriceRange([0, 5000]);
    setSearchTerm('');
    setSelectedBrands([]);
    setSelectedColors([]);
    setSelectedGenders([]); // NEW: Reset gender filter
    setSelectedMaterials([]); // NEW: Reset material filter
  };

  return (
    <>
      <Navbar />
      <PageContainer>
        <MainContent>
          <PageHeader>
            <PageTitle>
              {selectedCategory === 'all' ? 'Our Premium Collection' : `${selectedCategory}`}
            </PageTitle>
            
            <ControlsContainer>
              <SearchContainer>
                <FaSearch className="search-icon" />
                <SearchInput
                  type="text"
                  placeholder="Search for products, brands, or categories..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </SearchContainer>
              
              <SecondaryControls>
                <ViewToggle>
                  <ViewButton
                    active={viewMode === 'grid'}
                    onClick={() => setViewMode('grid')}
                  >
                    <BsGridFill />
                  </ViewButton>
                </ViewToggle>
                
                <SortSelect>
                  <select
                    value={sortOption}
                    onChange={(e) => setSortOption(e.target.value)}
                  >
                    <option value="featured">✨ Featured</option>
                    <option value="price-low">💰 Price: Low to High</option>
                    <option value="price-high">💎 Price: High to Low</option>
                    <option value="newest">🆕 Newest Arrivals</option>
                    <option value="discount">🔥 Best Discounts</option>
                  </select>
                  <BsChevronDown className="dropdown-icon" />
                </SortSelect>
                
                <FilterButton onClick={() => setShowFilters(true)}>
                  <FaFilter />
                  Filters
                </FilterButton>
              </SecondaryControls>
            </ControlsContainer>
          </PageHeader>

          {/* Filter Panel */}
          <FilterPanel show={showFilters}>
           <FilterHeader>
  <div style={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '2rem',
    paddingBottom: '1rem',
    borderBottom: '2px solid rgba(99, 102, 241, 0.1)'
  }}>
    <h2 style={{
      fontSize: '1.5rem',
      fontWeight: '700',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      margin: 0
    }}>🎯 Filter Products</h2>
    
    <button
      onClick={() => setShowFilters(false)}
      style={{
        padding: '0.75rem',
        borderRadius: '50%',
        background: 'rgba(99, 102, 241, 0.1)',
        border: 'none',
        cursor: 'pointer',
        color: '#667eea',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '40px',
        height: '40px',
        transition: 'all 0.3s ease'
      }}
      aria-label="Close filters"
      onMouseEnter={(e) => {
        e.currentTarget.style.background = 'rgba(99, 102, 241, 0.2)';
        e.currentTarget.style.transform = 'scale(1.1)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'rgba(99, 102, 241, 0.1)';
        e.currentTarget.style.transform = 'scale(1)';
      }}
    >
      <FaTimes style={{ fontSize: '1.2rem' }} />
    </button>
  </div>
  <CloseButton onClick={() => setShowFilters(false)} aria-label="Close filters">
    <FaTimes />
  </CloseButton>
</FilterHeader>

            
            {/* Category Filter */}
            <FilterSection>
              <h3>📂 Categories</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem', borderRadius: '8px', cursor: 'pointer' }}>
                  <input
                    type="radio"
                    name="category"
                    checked={selectedCategory === 'all'}
                    onChange={() => setSelectedCategory('all')}
                    style={{ accentColor: '#667eea' }}
                  />
                  <span>All Products</span>
                </label>
                {categories.map(category => (
                  <label key={category} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem', borderRadius: '8px', cursor: 'pointer' }}>
                    <input
                      type="radio"
                      name="category"
                      checked={selectedCategory === category}
                      onChange={() => setSelectedCategory(category)}
                      style={{ accentColor: '#667eea' }}
                    />
                    <span>{category}</span>
                  </label>
                ))}
              </div>
            </FilterSection>
            
            {/* Price Filter */}
            <FilterSection>
              <h3>💰 Price Range</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                  <input
                    type="number"
                    value={priceRange[0]}
                    onChange={(e) => handlePriceChange(e, 0)}
                    min="0"
                    max={priceRange[1]}
                    style={{ 
                      flex: 1, 
                      padding: '0.5rem', 
                      border: '2px solid rgba(99, 102, 241, 0.2)', 
                      borderRadius: '8px', 
                      outline: 'none' 
                    }}
                  />
                  <span style={{ display: 'flex', alignItems: 'center' }}>to</span>
                  <input
                    type="number"
                    value={priceRange[1]}
                    onChange={(e) => handlePriceChange(e, 1)}
                    min={priceRange[0]}
                    max="10000"
                    style={{ 
                      flex: 1, 
                      padding: '0.5rem', 
                      border: '2px solid rgba(99, 102, 241, 0.2)', 
                      borderRadius: '8px', 
                      outline: 'none' 
                    }}
                  />
                </div>
                <p style={{ textAlign: 'center', color: '#6b7280' }}>
                  ₹{priceRange[0]} - ₹{priceRange[1]}
                </p>
              </div>
            </FilterSection>

            {/* NEW: Gender Filter */}
            {allGenders.length > 0 && (
              <FilterSection>
                <h3>👤 Gender</h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                  {allGenders.map(gender => (
                    <label 
                      key={gender} 
                      style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: '0.5rem', 
                        padding: '0.5rem', 
                        borderRadius: '8px', 
                        cursor: 'pointer',
                        backgroundColor: selectedGenders.includes(gender) ? 'rgba(99, 102, 241, 0.1)' : 'transparent',
                        transition: 'all 0.3s ease'
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={selectedGenders.includes(gender)}
                        onChange={() => toggleGender(gender)}
                        style={{ accentColor: '#667eea' }}
                      />
                      <span>{gender.charAt(0).toUpperCase() + gender.slice(1)}</span>
                    </label>
                  ))}
                </div>
              </FilterSection>
            )}

            {/* Brand Filter */}
            {allBrands.length > 0 && (
              <FilterSection>
                <h3>🏷️ Brands</h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', maxHeight: '200px', overflowY: 'auto' }}>
                  {allBrands.map(brand => (
                    <label key={brand} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem', borderRadius: '8px', cursor: 'pointer' }}>
                      <input
                        type="checkbox"
                        checked={selectedBrands.includes(brand)}
                        onChange={() => toggleBrand(brand)}
                        style={{ accentColor: '#667eea' }}
                      />
                      <span>{brand.charAt(0).toUpperCase() + brand.slice(1)}</span>
                    </label>
                  ))}
                </div>
              </FilterSection>
            )}

            {/* NEW: Material Filter */}
            {allMaterials.length > 0 && (
              <FilterSection>
                <h3>🧵 Materials</h3>
                <div style={{ 
                  display: 'flex', 
                  flexDirection: 'column', 
                  gap: '0.5rem', 
                  maxHeight: '200px', 
                  overflowY: 'auto',
                  paddingRight: '0.5rem'
                }}>
                  {allMaterials.map(material => (
                    <label 
                      key={material} 
                      style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: '0.5rem', 
                        padding: '0.5rem', 
                        borderRadius: '8px', 
                        cursor: 'pointer',
                        backgroundColor: selectedMaterials.includes(material) ? 'rgba(99, 102, 241, 0.1)' : 'transparent',
                        transition: 'all 0.3s ease'
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={selectedMaterials.includes(material)}
                        onChange={() => toggleMaterial(material)}
                        style={{ accentColor: '#667eea' }}
                      />
                      <span>{material.charAt(0).toUpperCase() + material.slice(1)}</span>
                    </label>
                  ))}
                </div>
              </FilterSection>
            )}

            {/* Color Filter */}
            {allColors.length > 0 && (
              <FilterSection>
                <h3>🎨 Colors</h3>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                  {allColors.map(color => {
                    const colorValue = getColorValue(color);
                    return (
                      <div 
                        key={color}
                        onClick={() => toggleColor(color)}
                        style={{
                          width: '36px',
                          height: '36px',
                          borderRadius: '50%',
                          backgroundColor: colorValue,
                          border: selectedColors.includes(color) 
                            ? '3px solid #667eea' 
                            : '3px solid #e5e7eb',
                          cursor: 'pointer',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                          position: 'relative',
                          transition: 'all 0.3s ease'
                        }}
                        title={color.charAt(0).toUpperCase() + color.slice(1)}
                      >
                        {selectedColors.includes(color) && (
                          <div style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            color: colorValue === '#ffffff' ? '#667eea' : 'white',
                            fontSize: '14px',
                            fontWeight: 'bold'
                          }}>
                            ✓
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </FilterSection>
            )}
            
            <ResetButton
              onClick={() => {
                resetFilters();
                setShowFilters(false);
              }}
              style={{ width: '100%', marginTop: '1rem' }}
            >
              🔄 Reset & Apply
            </ResetButton>
          </FilterPanel>

          {/* Products Listing */}
          {loading ? (
            <LoadingContainer>
              <div className="spinner"></div>
              <p>Loading amazing products...</p>
            </LoadingContainer>
          ) : filteredProducts.length === 0 ? (
            <EmptyState>
              <div className="icon">🔍</div>
              <h3>No Products Found</h3>
              <p>Try adjusting your filters or search term to find what you're looking for.</p>
              <ResetButton onClick={resetFilters}>
                <HiOutlineSparkles style={{ marginRight: '0.5rem' }} />
                Reset Filters
              </ResetButton>
            </EmptyState>
          ) : (
            <ProductsGrid>
              {filteredProducts.map((product, index) => (
                <ProductCard 
                  key={product.id} 
                  index={index}
                  onClick={() => viewProductDetail(product.id)}
                >
                  <ProductImageContainer>
                    <img
                      src={product.images?.[0] || '/placeholder-product.jpg'}
                      alt={product.name}
                      onError={(e) => {
                        e.target.src = '/placeholder-product.jpg';
                      }}
                    />
                    
                    <ProductBadges>
                      {product.featured && (
                        <Badge color="linear-gradient(135deg, #f59e0b 0%, #d97706 100%)" shadowColor="rgba(245, 158, 11, 0.4)">
                          <HiOutlineSparkles /> Featured
                        </Badge>
                      )}
                      {product.discount > 0 && (
                        <Badge color="linear-gradient(135deg, #ef4444 0%, #dc2626 100%)" shadowColor="rgba(239, 68, 68, 0.4)">
                          <HiOutlineFire /> {product.discount}% OFF
                        </Badge>
                      )}
                    </ProductBadges>
                    
                    <ProductActions>
                      <ActionButton
                        onClick={(e) => {
                          e.stopPropagation();
                          viewProductDetail(product.id);
                        }}
                        title="Quick View"
                      >
                        <FaEye />
                      </ActionButton>
                    </ProductActions>
                  </ProductImageContainer>
                  
                  <ProductInfo>
                    <ProductTitle>{product.name}</ProductTitle>
                    <ProductBrand>{product.brand}</ProductBrand>
                    
                    <ProductRating>
                      <div className="stars">
                        {renderRating(product.rating || 4)}
                      </div>
                      <span className="review-count">
                        ({product.reviewCount || Math.floor(Math.random() * 50) + 10})
                      </span>
                    </ProductRating>
                    
                    <ProductPricing>
                      <div className="price-section">
                        <span className="current-price">
                          ₹{(product.price * (1 - (product.discount || 0) / 100)).toFixed(0)}
                        </span>
                        {product.discount > 0 && (
                          <span className="original-price">
                            ₹{product.price.toFixed(0)}
                          </span>
                        )}
                      </div>
                      {product.discount > 0 && (
                        <DiscountTag>
                          <FaTag /> Save ₹{(product.price * product.discount / 100).toFixed(0)}
                        </DiscountTag>
                      )}
                    </ProductPricing>
                  </ProductInfo>
                </ProductCard>
              ))}
            </ProductsGrid>
          )}
        </MainContent>
      </PageContainer>
      <Footer />
    </>
  );
};

export default ProductListing;